export enum StickyTypeEnum {
  Static = 'static',
  Sticky = 'sticky',
  Relative = 'relative',
}
